import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useFileStore } from 'src/features/files';
import { withAuth } from 'src/hoc';

import { useBoardStore } from '../../boards/store/useBoardStore';
import { deleteTask, duplicateTask } from '../api/useTasksService';
import { TaskEdit } from '../components/TaskEdit';
import { TaskLayout } from '../layouts/TaskLayout';
import { useTasksStore } from '../store/useTasksStore';

export const TaskPage = withAuth(() => {
  const router = useRouter();
  const [isDeletePromptOpen, setIsDeletePromptOpen] = useState(false);
  const [isDuplicatePromptOpen, setIsDuplicatePromptOpen] = useState<boolean>(false);
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;
  const boardsStore = useBoardStore();

  useEffect(() => {
    useTasksStore.setState({ isFullScreen: true });
    return () => useTasksStore.setState({ isFullScreen: false });
  }, []);

  const onToggleDeletePrompt =
    (isOpen = true) =>
    () => {
      setIsDeletePromptOpen(isOpen);
    };

  const onToggleDuplicatePrompt =
    (isOpen = true) =>
    () => {
      setIsDuplicatePromptOpen(isOpen);
    };

  const item = useTasksStore(
    useCallback((s) => s.tasks[router.query.taskId as string], [router.query.taskId])
  );

  //File fetched for getting file access to edit custom fields

  useEffect(() => {
    if (item?.fileId) {
      useFileStore.getState().fetchFile({ id: item?.fileId });
    }
  }, [item?.fileId]);

  useEffect(() => {
    if (item?.board?.id) {
      boardsStore.actions.fetchLabel({ id: item?.board?.id });
      boardsStore.actions.fetchSelectables({ id: item?.board?.id });
    }
  }, [item]);

  const handleDeleteTask = async () => {
    await deleteTask({ id: router.query.taskId as string });
    setIsDeletePromptOpen(false);
    router.push(
      router.query.routeBack === 'default'
        ? `/${mode}/${orgId}/files/${item?.fileId}`
        : router.query.routeBack === 'mytaskroute'
        ? `/${mode}/${orgId}/mytasks`
        : `/${mode}/${orgId}/files/${item?.fileId}?view=${item?.board?.id}&type=${
            router.query.routeBack || router.query.type
          }`
    );
  };

  const handleDuplicateTask = () => {
    duplicateTask({
      id: router.query.taskId as string,
    });

    setIsDuplicatePromptOpen(false);
    router.push(
      router.query.routeBack === 'default'
        ? `/${mode}/${orgId}/files/${item?.fileId}`
        : router.query.routeBack === 'mytaskroute'
        ? `/${mode}/${orgId}/mytasks`
        : `/${mode}/${orgId}/files/${item?.fileId}?view=${item?.board?.id}&type=${
            router.query.routeBack || router.query.type
          }`
    );
  };
  return (
    <TaskLayout>
      <div className="h-screen overflow-auto flex flex-col">
        {router.query.taskId ? (
          <TaskEdit
            onDelete={onToggleDeletePrompt()}
            onDuplicate={onToggleDuplicatePrompt(true)}
            id={router.query.taskId as string}
          />
        ) : (
          <></>
        )}
      </div>
      <Modal
        isOpen={isDeletePromptOpen}
        onClose={() => {
          setIsDeletePromptOpen(false);
        }}
      >
        <ModalOverlay />

        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <p className="mb-32 text-md text-gray-999">Are you sure you wish to proceed?</p>
          <div className="flex justify-end">
            <button
              onClick={() => {
                setIsDeletePromptOpen(false);
              }}
              className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
            >
              Cancel
            </button>
            <button
              className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
              onClick={handleDeleteTask}
            >
              Delete
            </button>
          </div>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isDuplicatePromptOpen}
        onClose={() => {
          setIsDuplicatePromptOpen(false);
        }}
      >
        <ModalOverlay />

        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <p className="mb-32 text-md text-gray-999">Are you sure you wish to proceed?</p>
          <div className="flex justify-end">
            <button
              onClick={() => {
                setIsDuplicatePromptOpen(false);
              }}
              className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
            >
              Cancel
            </button>
            <button
              className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
              onClick={handleDuplicateTask}
            >
              Duplicate
            </button>
          </div>
        </ModalContent>
      </Modal>
    </TaskLayout>
  );
});
